<template>
  <input-select
    v-model="parceiro"
    :options="parceiros"
    :single="single"
    :disabled="disabled"
    :required="required"
    :placeholder="placeholder"
  />
</template>

<script>
export default {
  data () {
    return {
      parceiros: []
    }
  },
  props: {
    value: null,
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    single: { type: Boolean, default: false },
    placeholder: {type: String, default: "Todas"}
  },
  computed: {
    parceiro: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('refresh')
      }
    }
  },
  methods: {
    loadComboParceiros () {
      let th = this
      th.parceiros = []

      th.$api.Parceiros.GetAll().then(function (response) {
        if (Array.isArray(response)) {
          response.forEach(function (item) {
            th.parceiros.push({
              value: item.codigo,
              text: item.nome.concat(
                ' ',
                '(CNPJ: ',
                th.$api.UI.Format.DocumentoFederal(item.documentoFederal),
                ')'
              )
            })
          })
        }
      })
    }
  },
  beforeMount () {
    this.loadComboParceiros()
  }
}
</script>
